<template>
  <div class="container">
    <home-nav />
    <div>
      <!--  内容区域  -->
      <router-view />
    </div>
    <div>
      <!--  底部区域  -->
      <footer-view />
    </div>
  </div>
</template>
<script>
import FooterView from "@/views/FooterView";
import HomeNav from "@/views/HomeNav";

export default {
  name: "HomePage",
  components: {
    HomeNav,
    FooterView,
  },
};
</script>
